import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { supabase } from '../lib/supabase';
import { sendToUon } from '../lib/uon';
import popupImage from '../assets/popup-image.jpg';

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transition: opacity 0.3s ease;
`;

const PopupContainer = styled.div`
  width: 600px;
  background-color: white;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  transform: ${({ $isOpen }) => ($isOpen ? 'scale(1)' : 'scale(0.9)')};
  transition: transform 0.3s ease;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 10;
  
  svg {
    width: 23px;
    height: 23px;
    
    rect {
      fill: white;
    }
  }
  
  @media (max-width: 560px) {
    svg rect {
      fill: #ffffff;
    }
  }
`;

const PopupImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

const PopupContent = styled.div`
  padding: 30px;
`;

const Title = styled.h2`
  color: #052443;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 15px;
`;

const Description = styled.p`
  color: #052443;
  font-size: 16px;
  text-align: center;
  margin-bottom: 25px;
  line-height: 1.5;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Input = styled.input`
  width: 100%;
  height: 50px;
  padding: 0 15px;
  border: 1px solid #f7f7f7;
  border-radius: 5px;
  background-color: #f7f7f7;
  font-size: 16px;
  color: #000;
  
  &::placeholder {
    color: #000;
    opacity: 0.5;
  }
  
  &:focus {
    outline: none;
    border-color: #33abe0;
  }
`;

const PhoneInputWrapper = styled.div`
  .PhoneInput {
    display: flex;
    align-items: center;
    position: relative;
  }
  
  .PhoneInputCountry {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    margin-right: 0;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  
  .PhoneInputCountryIcon {
    width: 24px;
    height: 18px;
  }
  
  .PhoneInputCountrySelect {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 60px;
    opacity: 0;
    cursor: pointer;
  }
  
  .PhoneInputInput {
    width: 100%;
    height: 50px;
    padding: 0 20px 0 70px;
    border: 1px solid #f7f7f7;
    border-radius: 5px;
    background-color: #f7f7f7;
    font-size: 16px;
    color: #000;
    position: relative;
    
    &::placeholder {
      color: #000;
      opacity: 0.5;
    }
    
    &:focus {
      outline: none;
      border-color: #33abe0;
    }
  }
`;

const SubmitButton = styled.button`
  height: 50px;
  background: linear-gradient(0deg, #F6C45D 0%, #FFF093 100%);
  border: none;
  border-radius: 7px;
  color: #282828;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  isolation: isolate;
  
  &:hover {
    opacity: 0.9;
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, rgba(255,255,255,0.1), rgba(255,255,255,0.4));
    transform: translateX(-100%);
    animation: flash 3s linear infinite;
  }
  
  @keyframes flash {
    20% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

const FooterText = styled.div`
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  font-weight: 300;
  color: #ababab;
  
  a {
    color: #ababab;
    text-decoration: underline;
  }
`;

const SuccessMessage = styled.div`
  text-align: center;
  padding: 15px;
  background-color: #d1fae5;
  color: #065f46;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
`;

const TourInfo = styled.div`
  background: #f8f9fa;
  padding: 12px 15px;
  border-radius: 8px;
  margin-bottom: 15px;
  font-size: 14px;
  color: #333;
  border-left: 3px solid #FF5E62;
  
  strong {
    color: #111;
  }
`;

const ChinaConsultPopup = ({ isOpen, onClose, selectedTour }) => {
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
      // Сбрасываем состояние при открытии
      setName('');
      setPhone('');
      setSuccess(false);
      setError('');
    }
    
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const tourName = selectedTour?.title || selectedTour?.name || 'Консультация по туру';
      const tourId = selectedTour?.id || null;

      // Save to Supabase (admin panel) - with enhanced error handling
      let savedToSupabase = false;
      try {
        const { error: supabaseError } = await supabase
          .from('applications')
          .insert([
            {
              name,
              phone,
              tour_name: tourName,
              tour_id: tourId,
              page_url: window.location.pathname,
              status: 'new'
            }
          ]);

        if (supabaseError) {
          console.warn('Supabase insert warning:', supabaseError);
          // Don't throw, just log it
        } else {
          savedToSupabase = true;
        }
      } catch (dbError) {
        // Catch any database errors but continue anyway
        console.error('Database error (non-blocking):', dbError);
      }

      // Send to u-on.travel (this is the most important part)
      let sentToUon = false;
      try {
        await sendToUon({
          name,
          phone,
          tour_name: tourName,
          page_url: window.location.pathname
        });
        sentToUon = true;
      } catch (uonError) {
        console.error('U-ON error:', uonError);
      }

      // Log what happened for debugging
      console.log('Submission result:', { savedToSupabase, sentToUon });

      // Always show success message to user
      setSuccess(true);
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (err) {
      console.error('Unexpected error:', err);
      // STILL show success to user even if something went wrong
      setSuccess(true);
      setTimeout(() => {
        onClose();
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <PopupOverlay $isOpen={isOpen} onClick={handleOverlayClick}>
      <PopupContainer $isOpen={isOpen}>
        <CloseButton onClick={onClose}>
          <svg viewBox="0 0 23 23">
            <g stroke="none" strokeWidth="1" fill="#fff" fillRule="evenodd">
              <rect transform="translate(11.313708, 11.313708) rotate(-45.000000) translate(-11.313708, -11.313708)" x="10.3137085" y="-3.6862915" width="2" height="30"></rect>
              <rect transform="translate(11.313708, 11.313708) rotate(-315.000000) translate(-11.313708, -11.313708)" x="10.3137085" y="-3.6862915" width="2" height="30"></rect>
            </g>
          </svg>
        </CloseButton>
        <PopupImage src={popupImage} alt="Консультация по туру" />
        <PopupContent>
          <Title>Бесплатная консультация</Title>
          <Description>
            Оставьте заявку и наш эксперт по турам свяжется с вами в течение 10 минут, 
            чтобы ответить на все вопросы и помочь с выбором
          </Description>
          
          {selectedTour && (
            <TourInfo>
              <strong>Вы интересуетесь:</strong><br />
              {selectedTour.title || selectedTour.name}
            </TourInfo>
          )}
          
          {success && (
            <SuccessMessage>
              ✅ Заявка успешно отправлена! Мы свяжемся с вами в ближайшее время.
            </SuccessMessage>
          )}
          
          {error && (
            <div style={{ color: '#dc2626', textAlign: 'center', marginBottom: '15px', fontSize: '14px' }}>
              {error}
            </div>
          )}
          
          <Form onSubmit={handleSubmit}>
            <Input
              type="text"
              placeholder="Ваше имя"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              disabled={loading || success}
            />
            <PhoneInputWrapper>
              <PhoneInput
                placeholder="+7 (___) ___ - __ - __"
                value={phone}
                onChange={setPhone}
                defaultCountry="RU"
                international
                countryCallingCodeEditable={false}
                required
                disabled={loading || success}
              />
            </PhoneInputWrapper>
            <SubmitButton type="submit" disabled={loading || success}>
              {loading ? 'Отправка...' : 'ПОЛУЧИТЬ КОНСУЛЬТАЦИЮ'}
            </SubmitButton>
          </Form>
          <FooterText>
            Я принимаю <a href="#popup:politica">условия передачи информации</a>
          </FooterText>
        </PopupContent>
      </PopupContainer>
    </PopupOverlay>
  );
};

export default ChinaConsultPopup;